import { style } from "@vanilla-extract/css";
import { primitiveTokens } from "../theme/ThemeTokens.css";

export const container = style({
  position: "relative",
  width: "100%"
});

export const totalSizeWrapper = style({
  position: "relative",
  width: "100%"
});

export const row = style({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  display: "grid"
});

export const cell = style({
  minWidth: 0,
  overflow: "hidden"
});

export const loadingRow = style({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: primitiveTokens.sizing["4x"]
});

export const emptyState = style({
  textAlign: "center",
  padding: `${primitiveTokens.sizing["10x"]} 0`,
  opacity: 0.5
});

export const loadingState = style({
  position: "relative",
  // No sizing token at this scale; matches ~one estimated card row of loading skeleton.
  minHeight: "320px"
});
